import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import store from './data/store';
import SiteHeaderAccount from './ui/main';

export const initTopAccount = () => {
    const $root = document.getElementById('header-account-placeholder');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <SiteHeaderAccount />
            </Provider>
        </React.StrictMode>,
        $root
    );
};